import { FONT_TITLE, FONT_COPY } from 'app/constants/AppConstants';

export default class OverlaySummary extends Phaser.Group {
  constructor(game, genericHud) {
    super(game);

    this.genericHud = genericHud;

    // overlay
    this.overlay = this.game.make.image(0, 0, 'chasegame_overlay');
    this.addChild(this.overlay);
    this.overlay.inputEnabled = true;

    // btn restart
    this.btnReplay = this.game.make.button(
      this.game.defaultWidth / 2 - 106,
      450,
      'chasegame_elements',
      null,
      null,
      'btn_replay',
      'btn_replay'
    );
    this.btnReplay.anchor.set(0.5);
    this.btnReplay.onInputDown.add(this.handlePressReplay, this);
    this.addChild(this.btnReplay);

    // btn continue
    this.btnContinue = this.game.make.button(
      this.game.defaultWidth / 2 + 106,
      450,
      'chasegame_elements',
      null,
      null,
      'btn_continue',
      'btn_continue'
    );
    this.btnContinue.anchor.set(0.5);
    this.btnContinue.onInputDown.add(this.handlePressContinue, this);
    this.addChild(this.btnContinue);
  }

  handlePressReplay() {
    this.genericHud.startGame();
  }

  handlePressContinue() {
    this.game.gameController.endMiniGame();
  }
}



// WEBPACK FOOTER //
// ./js/app/games/chase/ui/OverlaySummary.js